// extracted by mini-css-extract-plugin
export default {"root":"DraggableColorBox_root__qkn1i","deleteIcon":"DraggableColorBox_deleteIcon__XwkhU","boxContent":"DraggableColorBox_boxContent__uR1ax"};